import StatsPlugin from './stats'
export default StatsPlugin



// WEBPACK FOOTER //
// ./src/plugins/stats/index.js